// Imports
import { findLink } from "src/lib/utils";
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { Noticeboard } from '../../noticeboard/jsx/noticeboard.jsx';
import { Calendar } from 'src/modules/calendar/jsx/component.jsx';
import { MySchedule } from 'src/modules/schedule/jsx/my-schedule.jsx';
import { UniversityEvents } from 'src/modules/schedule/jsx/university-events.jsx';
import { sendXHR, failedRequest } from "src/lib/utils";


// Stateful components

export class HomeTabs extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            'tab_list': ['Noticeboard', 'Schedule', 'Events'],
            'active_tab': 'Noticeboard'
        };

        //Binds
        this.changeActiveTab = this.changeActiveTab.bind(this);
        this.getEventsData = this.getEventsData.bind(this);
        this.processEventsData = this.processEventsData.bind(this);
    }

    componentDidMount() {
        var this_component = this;

        this_component.getEventsData();
    }

    // Get all portal pages
    getEventsData() {
        var this_component = this;
        var endpoints_container = document.querySelector('#endpoints');
        var events_url = endpoints_container.getAttribute('data-events');

        var xhr_parameters = {
            'request_url': events_url,
            'request_success': this_component.processEventsData,
            'request_failure': failedRequest,
            'request_extras': ""
        };

        sendXHR(xhr_parameters, 'GET');
    }

    // Save all portal pages and indicate the portal has finished loading
    processEventsData(response) {
        var this_component = this;
        var all_events = JSON.parse(response);
        this_component.setState({
            "event_data": all_events
        });
    }


    //
    // Events
    //

    changeActiveTab(event) {
        event.preventDefault();

        var this_component = this;
        var target_link = findLink(event);
        var target_tab = target_link.getAttribute('data-tab');

        this_component.setState({
            'active_tab': target_tab
        });
    }


    //
    // Functions
    //

    getTabContent() {
        var this_component = this;
        var portal_context = this_component['context'];
        var active_tab = this_component['state']['active_tab'];
        var events_data = this_component['state']['event_data'];

        switch(active_tab) {
            case 'Noticeboard':
                return (
                    <Noticeboard type="partial" />
                );
            case 'Schedule':
                return (
                    <>
                        <Calendar />
                        <div className="schedule__wrapper">
                            <MySchedule />
                        </div>
                    </>
                );
            case 'Events':
                return (
                    <>
                        <Calendar />
                        <div className="schedule__wrapper">
                            <UniversityEvents date={portal_context.selected_date} data={events_data}/>
                        </div>
                    </>
                );
            default:
                return null;
        }
    }


    //
    // Render
    //

    renderTabs() {
        var this_component = this;
        var tab_list = this_component['state']['tab_list'];
        var active_tab = this_component['state']['active_tab'];
        var click_handler = this_component.changeActiveTab;
        var portal_context = this_component['context'];

        var rendered_tabs = tab_list.map(function(tab, tab_index){
            var tab_class = 'home-tabs__item';

            if(tab === active_tab) {
                tab_class += ' active';
            }

            switch(tab) {
                case 'Noticeboard':
                    return (
                        <a key={tab_index} href="#" className={tab_class} data-tab={tab} onClick={click_handler}>
                            {tab} <span className="home-tabs__count-label">{portal_context["notification_count"]}</span>
                        </a>
                    );
                default:
                    return (
                        <a key={tab_index} href="#" className={tab_class} data-tab={tab} onClick={click_handler}>{tab}</a>
                    );
            }
        });

        return rendered_tabs;
    }

    render() {
        var this_component = this;
        var active_tab = this_component['state']['active_tab'];
        var tab_list = this_component.renderTabs();
        var tab_content = this_component.getTabContent();
                
        return (
            <>
                <div className="home-tabs__wrapper">
                    <div className="home-tabs inner">
                        {tab_list}
                    </div>
                </div>
                {tab_content}
            </>
        );
    }

};

HomeTabs.contextType = PortalContext;
